"use strict";

var _defineProperty = require("/Users/arjunjain/Borderless/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/defineProperty");

var _toConsumableArray = require("/Users/arjunjain/Borderless/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/toConsumableArray");

var _exports$schemasByTyp;

Object.defineProperty(exports, "__esModule", {
  value: true
});

var serializePrimitives_1 = require("./serializePrimitives");

var parsePrimitives_1 = require("./parsePrimitives");

var schemaTypes_1 = require("./schemaTypes");

var serialize_1 = require("./serialize"); //Todo: import this enums from ts-types package


var TRANSACTION_TYPE;

(function (TRANSACTION_TYPE) {
  TRANSACTION_TYPE[TRANSACTION_TYPE["GENESIS"] = 1] = "GENESIS";
  TRANSACTION_TYPE[TRANSACTION_TYPE["PAYMENT"] = 2] = "PAYMENT";
  TRANSACTION_TYPE[TRANSACTION_TYPE["ISSUE"] = 3] = "ISSUE";
  TRANSACTION_TYPE[TRANSACTION_TYPE["TRANSFER"] = 4] = "TRANSFER";
  TRANSACTION_TYPE[TRANSACTION_TYPE["REISSUE"] = 5] = "REISSUE";
  TRANSACTION_TYPE[TRANSACTION_TYPE["BURN"] = 6] = "BURN";
  TRANSACTION_TYPE[TRANSACTION_TYPE["EXCHANGE"] = 7] = "EXCHANGE";
  TRANSACTION_TYPE[TRANSACTION_TYPE["LEASE"] = 8] = "LEASE";
  TRANSACTION_TYPE[TRANSACTION_TYPE["CANCEL_LEASE"] = 9] = "CANCEL_LEASE";
  TRANSACTION_TYPE[TRANSACTION_TYPE["ALIAS"] = 10] = "ALIAS";
  TRANSACTION_TYPE[TRANSACTION_TYPE["MASS_TRANSFER"] = 11] = "MASS_TRANSFER";
  TRANSACTION_TYPE[TRANSACTION_TYPE["DATA"] = 12] = "DATA";
  TRANSACTION_TYPE[TRANSACTION_TYPE["SET_SCRIPT"] = 13] = "SET_SCRIPT";
  TRANSACTION_TYPE[TRANSACTION_TYPE["SPONSORSHIP"] = 14] = "SPONSORSHIP";
  TRANSACTION_TYPE[TRANSACTION_TYPE["SET_ASSET_SCRIPT"] = 15] = "SET_ASSET_SCRIPT";
  TRANSACTION_TYPE[TRANSACTION_TYPE["INVOKE_SCRIPT"] = 16] = "INVOKE_SCRIPT";
})(TRANSACTION_TYPE = exports.TRANSACTION_TYPE || (exports.TRANSACTION_TYPE = {}));

var shortConverter = {
  toBytes: serializePrimitives_1.SHORT,
  fromBytes: parsePrimitives_1.P_SHORT
};
var intConverter = {
  toBytes: serializePrimitives_1.INT,
  fromBytes: parsePrimitives_1.P_INT
};
var txFields;

(function (txFields) {
  //Field constructors
  txFields.longField = function (name) {
    return [name, {
      toBytes: serializePrimitives_1.LONG,
      fromBytes: parsePrimitives_1.P_LONG
    }];
  };

  txFields.byteField = function (name) {
    return [name, {
      toBytes: serializePrimitives_1.BYTE,
      fromBytes: parsePrimitives_1.P_BYTE
    }];
  };

  txFields.booleanField = function (name) {
    return [name, {
      toBytes: serializePrimitives_1.BOOL,
      fromBytes: parsePrimitives_1.P_BOOLEAN
    }];
  };

  txFields.stringField = function (name) {
    return [name, {
      toBytes: serializePrimitives_1.LEN(serializePrimitives_1.SHORT)(serializePrimitives_1.STRING),
      fromBytes: parsePrimitives_1.P_STRING_VAR(parsePrimitives_1.P_SHORT)
    }];
  };

  txFields.base58field32 = function (name) {
    return [name, {
      toBytes: serializePrimitives_1.BASE58_STRING,
      fromBytes: parsePrimitives_1.P_BASE58_FIXED(32)
    }];
  }; // String 'WAVES' often used instead of null. That's why we should serialize it as null


  txFields.base58Option32 = function (name) {
    return [name, {
      toBytes: function toBytes(s) {
        return s === 'WAVES' ? serializePrimitives_1.OPTION(serializePrimitives_1.BASE58_STRING)(null) : serializePrimitives_1.OPTION(serializePrimitives_1.BASE58_STRING)(s);
      },
      fromBytes: parsePrimitives_1.P_OPTION(parsePrimitives_1.P_BASE58_FIXED(32))
    }];
  };

  txFields.base64field = function (name) {
    return [name, {
      toBytes: serializePrimitives_1.LEN(serializePrimitives_1.SHORT)(serializePrimitives_1.BASE64_STRING),
      fromBytes: parsePrimitives_1.P_BASE64(parsePrimitives_1.P_SHORT)
    }];
  };

  txFields.byteConstant = function (byte) {
    return ['noname', {
      toBytes: function toBytes() {
        return Uint8Array.from([byte]);
      },
      fromBytes: function fromBytes() {
        return {
          value: undefined,
          shift: 1
        };
      }
    }];
  }; // Primitive fields


  txFields.alias = ['alias', {
    toBytes: serializePrimitives_1.LEN(serializePrimitives_1.SHORT)(serializePrimitives_1.STRING),
    fromBytes: parsePrimitives_1.byteNewAliasToString
  }];
  txFields.amount = txFields.longField('amount');
  txFields.assetDescription = txFields.stringField('description');
  txFields.assetId = txFields.base58field32('assetId');
  txFields.assetName = txFields.stringField('name');
  txFields.attachment = ['attachment', {
    toBytes: serializePrimitives_1.LEN(serializePrimitives_1.SHORT)(serializePrimitives_1.BASE58_STRING),
    fromBytes: parsePrimitives_1.P_BASE58_VAR(parsePrimitives_1.P_SHORT)
  }];
  txFields.chainId = txFields.byteField('chainId');
  txFields.decimals = txFields.byteField('decimals');
  txFields.fee = txFields.longField('fee');
  txFields.leaseAssetId = txFields.base58Option32('leaseAssetId');
  txFields.leaseId = txFields.base58field32('leaseId');
  txFields.optionalAssetId = txFields.base58Option32('assetId');
  txFields.quantity = txFields.longField('quantity');
  txFields.reissuable = txFields.booleanField('reissuable');
  txFields.recipient = ['recipient', {
    toBytes: serializePrimitives_1.ADDRESS_OR_ALIAS,
    fromBytes: parsePrimitives_1.byteToAddressOrAlias
  }];
  txFields.script = ['script', {
    toBytes: serializePrimitives_1.SCRIPT,
    fromBytes: parsePrimitives_1.byteToScript
  }];
  txFields.senderPublicKey = txFields.base58field32('senderPublicKey');
  txFields.signature = ['signature', {
    toBytes: serializePrimitives_1.BASE58_STRING,
    fromBytes: parsePrimitives_1.P_BASE58_FIXED(64)
  }];
  txFields.timestamp = txFields.longField('timestamp');
  txFields.type = txFields.byteField('type');
  txFields.version = txFields.byteField('version'); // Complex fields

  txFields.proofs = ['proofs', {
    type: 'array',
    items: {
      toBytes: serializePrimitives_1.LEN(serializePrimitives_1.SHORT)(serializePrimitives_1.BASE58_STRING),
      fromBytes: parsePrimitives_1.P_BASE58_VAR(parsePrimitives_1.P_SHORT)
    }
  }];
  var transfer = {
    type: 'object',
    schema: [txFields.recipient, txFields.amount]
  };
  txFields.transfers = ['transfers', {
    type: 'array',
    items: transfer
  }];
  var dataTxItem = {
    type: 'dataTxField',
    items: new Map([[schemaTypes_1.DATA_FIELD_TYPE.INTEGER, {
      toBytes: serializePrimitives_1.LONG,
      fromBytes: parsePrimitives_1.P_LONG
    }], [schemaTypes_1.DATA_FIELD_TYPE.BOOLEAN, {
      toBytes: serializePrimitives_1.BOOL,
      fromBytes: parsePrimitives_1.P_BOOLEAN
    }], [schemaTypes_1.DATA_FIELD_TYPE.BINARY, {
      toBytes: serializePrimitives_1.LEN(serializePrimitives_1.SHORT)(serializePrimitives_1.BASE64_STRING),
      fromBytes: parsePrimitives_1.P_BASE64(parsePrimitives_1.P_SHORT)
    }], [schemaTypes_1.DATA_FIELD_TYPE.STRING, {
      toBytes: serializePrimitives_1.LEN(serializePrimitives_1.SHORT)(serializePrimitives_1.STRING),
      fromBytes: parsePrimitives_1.P_STRING_VAR(parsePrimitives_1.P_SHORT)
    }]])
  };
  txFields.data = ['data', {
    type: 'array',
    items: dataTxItem
  }];
  var functionArgument = schemaTypes_1.anyOf([[0, {
    toBytes: serializePrimitives_1.LONG,
    fromBytes: parsePrimitives_1.P_LONG
  }, 'integer'], [1, {
    toBytes: serializePrimitives_1.LEN(serializePrimitives_1.INT)(serializePrimitives_1.BASE64_STRING),
    fromBytes: parsePrimitives_1.P_BASE64(parsePrimitives_1.P_INT)
  }, 'binary'], [2, {
    toBytes: serializePrimitives_1.LEN(serializePrimitives_1.INT)(serializePrimitives_1.STRING),
    fromBytes: parsePrimitives_1.P_STRING_VAR(parsePrimitives_1.P_INT)
  }, 'string'], [6, {
    toBytes: function toBytes() {
      return Uint8Array.from([]);
    },
    fromBytes: function fromBytes() {
      return {
        value: true,
        shift: 0
      };
    }
  }, 'boolean'], [7, {
    toBytes: function toBytes() {
      return Uint8Array.from([]);
    },
    fromBytes: function fromBytes() {
      return {
        value: false,
        shift: 0
      };
    }
  }, 'boolean']], {
    valueField: 'value'
  });
  txFields.functionCall = ['call', {
    type: 'object',
    optional: true,
    schema: [// special bytes to indicate function call. Used in Serde serializer
    txFields.byteConstant(9), txFields.byteConstant(1), ['function', {
      toBytes: serializePrimitives_1.LEN(serializePrimitives_1.INT)(serializePrimitives_1.STRING),
      fromBytes: parsePrimitives_1.P_STRING_VAR(parsePrimitives_1.P_INT)
    }], ['args', {
      type: 'array',
      toBytes: serializePrimitives_1.INT,
      fromBytes: parsePrimitives_1.P_INT,
      items: functionArgument
    }]]
  }];
  txFields.payment = {
    type: 'object',
    withLength: shortConverter,
    schema: [txFields.amount, txFields.optionalAssetId]
  };
  txFields.payments = ['payment', {
    type: 'array',
    items: txFields.payment
  }];
})(txFields = exports.txFields || (exports.txFields = {}));

exports.orderSchemaV1 = {
  type: 'object',
  schema: [txFields.senderPublicKey, txFields.base58field32('matcherPublicKey'), ['assetPair', {
    type: 'object',
    schema: [txFields.base58Option32('amountAsset'), txFields.base58Option32('priceAsset')]
  }], ['orderType', {
    toBytes: function toBytes(type) {
      return serializePrimitives_1.BYTE(type === 'sell' ? 1 : 0);
    },
    fromBytes: function fromBytes(bytes) {
      var start = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
      return parsePrimitives_1.P_BYTE(bytes, start).value === 1 ? {
        value: 'sell',
        shift: 1
      } : {
        value: 'buy',
        shift: 1
      };
    }
  }], txFields.longField('price'), txFields.longField('amount'), txFields.timestamp, txFields.longField('expiration'), txFields.longField('matcherFee')]
};
exports.orderSchemaV2 = {
  type: 'object',
  schema: [txFields.version].concat(_toConsumableArray(exports.orderSchemaV1.schema))
}; // In order v3 amount and price fields are flipped

exports.orderSchemaV3 = {
  type: 'object',
  schema: [].concat(_toConsumableArray(exports.orderSchemaV2.schema), [['matcherFeeAssetId', txFields.optionalAssetId[1]]])
};
exports.aliasSchemaV2 = {
  type: 'object',
  schema: [txFields.type, txFields.version, txFields.senderPublicKey, [['alias', 'chainId'], {
    type: 'object',
    withLength: shortConverter,
    schema: [txFields.byteConstant(2), txFields.chainId, txFields.alias]
  }], txFields.fee, txFields.timestamp]
};
exports.burnSchemaV2 = {
  type: 'object',
  schema: [txFields.type, txFields.version, txFields.chainId, txFields.senderPublicKey, txFields.assetId, txFields.quantity, txFields.fee, txFields.timestamp]
};
exports.cancelLeaseSchemaV2 = {
  type: 'object',
  schema: [txFields.type, txFields.version, txFields.chainId, txFields.senderPublicKey, txFields.fee, txFields.timestamp, txFields.leaseId]
};
exports.invokeScriptSchemaV1 = {
  type: 'object',
  schema: [txFields.type, txFields.version, txFields.chainId, txFields.senderPublicKey, ['dApp', txFields.recipient[1]], txFields.functionCall, txFields.payments, txFields.fee, ['feeAssetId', txFields.optionalAssetId[1]], txFields.timestamp]
};
exports.dataSchemaV1 = {
  type: 'object',
  schema: [txFields.type, txFields.version, txFields.senderPublicKey, txFields.data, txFields.timestamp, txFields.fee]
};
exports.proofsSchemaV0 = {
  type: 'object',
  schema: [['signature', {
    toBytes: serializePrimitives_1.BASE58_STRING,
    fromBytes: parsePrimitives_1.P_BASE58_FIXED(64)
  }]]
};
exports.proofsSchemaV1 = {
  type: 'object',
  schema: [txFields.byteConstant(1), txFields.proofs]
};
var orderSchemaV0WithSignature = {
  type: 'object',
  schema: [].concat(_toConsumableArray(exports.orderSchemaV1.schema), [txFields.signature])
}; //ExchangeV0 needs both orders length to be present before actual order bytes.
// That's why there are two separate rules for oder1 and order2 fields. First one serializes order and writes length.
// Seconds serializes and writes whole order. When deserialize, second rule overwrites order fields in js object

exports.exchangeSchemaV1 = {
  type: 'object',
  schema: [txFields.type, ['order1', {
    fromBytes: function fromBytes() {
      return {
        value: undefined,
        shift: 4
      };
    },
    toBytes: function toBytes(order) {
      return serializePrimitives_1.INT(serialize_1.serializerFromSchema(orderSchemaV0WithSignature)(order).length);
    }
  }], ['order2', {
    fromBytes: function fromBytes() {
      return {
        value: undefined,
        shift: 4
      };
    },
    toBytes: function toBytes(order) {
      return serializePrimitives_1.INT(serialize_1.serializerFromSchema(orderSchemaV0WithSignature)(order).length);
    }
  }], ['order1', orderSchemaV0WithSignature], ['order2', orderSchemaV0WithSignature], txFields.longField('price'), txFields.longField('amount'), txFields.longField('buyMatcherFee'), txFields.longField('sellMatcherFee'), txFields.longField('fee'), txFields.longField('timestamp')]
};
var anyOrder = schemaTypes_1.anyOf([[1, {
  type: 'object',
  //order v1 length is serialized without orderVersion
  withLength: {
    toBytes: function toBytes(x) {
      return serializePrimitives_1.INT(x - 1);
    },
    fromBytes: function fromBytes(x) {
      var _parsePrimitives_1$P_ = parsePrimitives_1.P_INT(x),
          value = _parsePrimitives_1$P_.value,
          shift = _parsePrimitives_1$P_.shift;

      return {
        value: value + 1,
        shift: shift
      };
    }
  },
  schema: [txFields.byteConstant(1)].concat(_toConsumableArray(exports.orderSchemaV1.schema), _toConsumableArray(exports.proofsSchemaV0.schema))
}], [2, {
  type: 'object',
  withLength: intConverter,
  schema: [].concat(_toConsumableArray(exports.orderSchemaV2.schema), _toConsumableArray(exports.proofsSchemaV1.schema))
}]], {
  discriminatorField: 'version',
  discriminatorBytePos: 4
});
exports.exchangeSchemaV2 = {
  type: 'object',
  schema: [txFields.byteConstant(0), txFields.type, txFields.version, ['order1', anyOrder], ['order2', anyOrder], txFields.longField('price'), txFields.longField('amount'), txFields.longField('buyMatcherFee'), txFields.longField('sellMatcherFee'), txFields.longField('fee'), txFields.longField('timestamp')]
};
exports.issueSchemaV2 = {
  type: 'object',
  schema: [txFields.type, txFields.version, txFields.chainId, txFields.senderPublicKey, txFields.assetName, txFields.assetDescription, txFields.quantity, txFields.decimals, txFields.reissuable, txFields.fee, txFields.timestamp, txFields.script]
};
exports.leaseSchemaV2 = {
  type: 'object',
  schema: [txFields.type, txFields.version, txFields.leaseAssetId, txFields.senderPublicKey, txFields.recipient, txFields.amount, txFields.fee, txFields.timestamp]
};
exports.massTransferSchemaV1 = {
  type: 'object',
  schema: [txFields.type, txFields.version, txFields.senderPublicKey, txFields.optionalAssetId, txFields.transfers, txFields.timestamp, txFields.fee, txFields.attachment]
};
exports.reissueSchemaV2 = {
  type: 'object',
  schema: [txFields.type, txFields.version, txFields.chainId, txFields.senderPublicKey, txFields.assetId, txFields.quantity, txFields.reissuable, txFields.fee, txFields.timestamp]
};
exports.setAssetScriptSchemaV1 = {
  type: 'object',
  schema: [txFields.type, txFields.version, txFields.chainId, txFields.senderPublicKey, txFields.assetId, txFields.fee, txFields.timestamp, txFields.script]
};
exports.setScriptSchemaV1 = {
  type: 'object',
  schema: [txFields.type, txFields.version, txFields.chainId, txFields.senderPublicKey, txFields.script, txFields.fee, txFields.timestamp]
};
exports.sponsorshipSchemaV1 = {
  type: 'object',
  schema: [txFields.type, txFields.version, txFields.senderPublicKey, txFields.assetId, txFields.longField('minSponsoredAssetFee'), txFields.fee, txFields.timestamp]
};
exports.transferSchemaV2 = {
  type: 'object',
  schema: [txFields.type, txFields.version, txFields.senderPublicKey, txFields.optionalAssetId, ['feeAssetId', txFields.optionalAssetId[1]], txFields.timestamp, txFields.amount, txFields.fee, txFields.recipient, txFields.attachment]
};
/**
 * Maps transaction types to schemas object. Schemas are written by keys. 1 equals no version or version 1
 */

exports.schemasByTypeMap = (_exports$schemasByTyp = {}, _defineProperty(_exports$schemasByTyp, TRANSACTION_TYPE.GENESIS, {}), _defineProperty(_exports$schemasByTyp, TRANSACTION_TYPE.PAYMENT, {}), _defineProperty(_exports$schemasByTyp, TRANSACTION_TYPE.ISSUE, {
  2: exports.issueSchemaV2
}), _defineProperty(_exports$schemasByTyp, TRANSACTION_TYPE.TRANSFER, {
  2: exports.transferSchemaV2
}), _defineProperty(_exports$schemasByTyp, TRANSACTION_TYPE.REISSUE, {
  2: exports.reissueSchemaV2
}), _defineProperty(_exports$schemasByTyp, TRANSACTION_TYPE.BURN, {
  2: exports.burnSchemaV2
}), _defineProperty(_exports$schemasByTyp, TRANSACTION_TYPE.EXCHANGE, {
  1: exports.exchangeSchemaV1,
  2: exports.exchangeSchemaV2
}), _defineProperty(_exports$schemasByTyp, TRANSACTION_TYPE.LEASE, {
  2: exports.leaseSchemaV2
}), _defineProperty(_exports$schemasByTyp, TRANSACTION_TYPE.CANCEL_LEASE, {
  2: exports.cancelLeaseSchemaV2
}), _defineProperty(_exports$schemasByTyp, TRANSACTION_TYPE.ALIAS, {
  2: exports.aliasSchemaV2
}), _defineProperty(_exports$schemasByTyp, TRANSACTION_TYPE.MASS_TRANSFER, {
  1: exports.massTransferSchemaV1
}), _defineProperty(_exports$schemasByTyp, TRANSACTION_TYPE.DATA, {
  1: exports.dataSchemaV1
}), _defineProperty(_exports$schemasByTyp, TRANSACTION_TYPE.SET_SCRIPT, {
  1: exports.setScriptSchemaV1
}), _defineProperty(_exports$schemasByTyp, TRANSACTION_TYPE.SPONSORSHIP, {
  1: exports.sponsorshipSchemaV1
}), _defineProperty(_exports$schemasByTyp, TRANSACTION_TYPE.SET_ASSET_SCRIPT, {
  1: exports.setAssetScriptSchemaV1
}), _defineProperty(_exports$schemasByTyp, TRANSACTION_TYPE.INVOKE_SCRIPT, {
  1: exports.invokeScriptSchemaV1
}), _exports$schemasByTyp);
exports.orderVersionMap = {
  1: exports.orderSchemaV1,
  2: exports.orderSchemaV2,
  3: exports.orderSchemaV3
};

function getTransactionSchema(type, version) {
  var schemas = exports.schemasByTypeMap[type];

  if (typeof schemas !== 'object') {
    throw new Error("Incorrect tx type: ".concat(type));
  }

  var schema = schemas[version || 1];

  if (typeof schema !== 'object') {
    throw new Error("Incorrect tx version: ".concat(version));
  }

  return schema;
}

exports.getTransactionSchema = getTransactionSchema;